module.exports = __webpack_public_path__ + "img/277498df4c724904908dfb5f7e9cab86-640.a52c8fbc.jpg";